module.exports = new __parcel__URL__("starfleet.b320439b.png").toString();